module.exports = require('./helpers/bundle-url').getBundleURL('dgt5F') + "profile-picture-1.7495cca9.jpg";